import script from "./ChartTopCompetidores.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartTopCompetidores.vue?vue&type=script&setup=true&lang=js"

import "./ChartTopCompetidores.vue?vue&type=style&index=0&id=566a541a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-566a541a"]])

export default __exports__